/* eslint-disable no-multiple-empty-lines */
import React, { useState, useEffect } from 'react'
import { getCurrencyByReq } from 'AccountsUtils'
import OneWay from 'SVGPath/one-way-black.svg'

const paxTypeMap = { ADT: 'adult', INF: 'infant', CHD: 'child' }
const FareRules = ({
  data = null,
  isPWA,
  property = null,
  borderBottom = false,
  showArrDest = true,
  noOuterBorder = false,
  hasTopPad = true,
  isDeskTopView = false,
  indx = 0
}) => {
  const { fareDetails } = data || {}
  const {
    arrivalCity,
    departureCity,
    cancelCharges,
    amendSameFareCharges,
    amendHigherFareCharges,
    currency
  } = fareDetails || {}
  const headerText =
    cancelCharges || property === 'cancelCharges' ? 'cancel' : 'amend'
  let justCharges = property ?
    [{ title: null, rules: fareDetails[property] }] :
    null
  const [fareType, setfareType] = useState(false)
  useEffect(() => {
    setfareType(
      justCharges && justCharges.filter(item => item.title).length > 0
    )
  }, [justCharges])
  if (cancelCharges && !property) {
    justCharges = [{ title: null, rules: cancelCharges }]
  }
  if (
    (amendSameFareCharges || amendHigherFareCharges) &&
    property !== 'cancelCharges'
  ) {
    justCharges = [
      { title: 'same class', rules: amendSameFareCharges },
      { title: 'higher class', rules: amendHigherFareCharges }
    ]
  }

  return (
    <If condition={justCharges}>
      <If condition={isPWA}>
        {justCharges &&
          justCharges.map(({ rules, title }) => (
            <If condition={rules && rules.length > 0}>
              <div
                key={`fare_rules_${Math.random()}`}
                className={`${noOuterBorder || isDeskTopView ? '' : 'px-4'} ${
                  hasTopPad ? 'py-2' : 'pb-2'
                } ${borderBottom ? 'border-bottom-grey' : ''}`}
              >
                <If condition={title}>
                  <p
                    className={`${
                      isDeskTopView ? 'fs-10 pt-1 pb-1' : 'pb -2 fw-500 fs-13'
                    } tt-sentence`}
                  >
                    {title}
                  </p>
                </If>
                <If condition={showArrDest}>
                  <div className="flex fs-13 pb-2 pr-2 fw-500">
                    <p>
                      {departureCity} <OneWay /> {arrivalCity}
                    </p>
                  </div>
                </If>
                <table
                  className={`w-100p ${isDeskTopView ? 'fs-10' : 'fs-13'}`}
                >
                  <thead className="c-grey-60 ta-left">
                    <tr className={`${isDeskTopView ? 'c-white' : ''}`}>
                      <th className="py-1 pr-1 tt-sentence">
                        {headerText} Before
                      </th>
                      <th className="py-1 ta-right tt-capitalize">
                        Airline Charges
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {rules &&
                      rules.map(({ chargesPerPaxList, paxType }) => {
                        return (
                          chargesPerPaxList &&
                          chargesPerPaxList.map(
                            ({ charges, timeInterval, to, endTime }) => (
                              <tr>
                                <td
                                  className={`${
                                    isDeskTopView ? 'c-grey-30' : ''
                                  } py-1 pr-1`}
                                >
                                  {endTime}
                                </td>
                                <td
                                  className={`${
                                    isDeskTopView ? 'c-grey-30' : ''
                                  } py-1 ta-right`}
                                >
                                  {getCurrencyByReq(charges, currency)}/
                                  {paxTypeMap[paxType] || ''}
                                </td>
                              </tr>
                            )
                          )
                        )
                      })}
                  </tbody>
                </table>
              </div>
            </If>
          ))}
        <Else />
        <If
          condition={
            justCharges &&
            justCharges[0].rules.length > 0 &&
            justCharges.length > 0
          }
        >
          <div
            key={`fare_rules_${Math.random()}`}
            className={`${noOuterBorder ? '' : 'px-4'} ${
              hasTopPad ? 'py-2' : 'pb-2'
            } ${borderBottom ? 'border-bottom-grey' : ''}`}
          >
            <table className="w-100p fs-13">
              {indx === 0 && (
                <thead className="c-grey-60 border-bottom-grey">
                  <tr className="border-top-grey">
                    <th className="ta-left fs-caption-2 py-2 fw-600">
                      Flights
                    </th>
                    <th className="ta-left fs-caption-2 py-2 fw-600">
                      Before date &amp; time
                    </th>
                    <th className="ta-left fs-caption-2 py-2 fw-600">
                      Airline charges
                    </th>
                  </tr>
                </thead>
              )}
              {justCharges &&
                justCharges.map(({ rules, title }) => {
                  return (
                    <React.Fragment>
                      {// eslint-disable-next-line max-len
                        rules &&
                        rules.map(
                          ({ chargesPerPaxList, paxType }) => chargesPerPaxList &&
                            chargesPerPaxList.map(
                              ({ charges, timeInterval, to, endTime }, idx) => {
                                return (
                                  <tbody>
                                    <tr
                                      key={`fare_rules_data_${Math.random()}`}
                                    >
                                      <If condition={idx === 0}>
                                        <td
                                          className={`pr-1 ${
                                            fareType ? 'w-200' : 'w-250'
                                          } ${
                                            idx !== 0 &&
                                            idx !== chargesPerPaxList.length - 1 ?
                                              'py-2' :
                                              ''
                                          } ${idx === 0 ? 'pt-4 pb-2' : ''} ${
                                            idx === chargesPerPaxList.length - 1 ?
                                              'pt-2 pb-4' :
                                              ''
                                          }`}
                                        >
                                          {departureCity} <OneWay />{' '}
                                          {arrivalCity}
                                        </td>
                                        <Else />
                                        <td
                                          className={`pr-1 ${
                                            fareType ? 'w-200' : 'w-250'
                                          } ${
                                            idx !== 0 &&
                                            idx !== chargesPerPaxList.length - 1 ?
                                              'py-2' :
                                              ''
                                          } ${idx === 0 ? 'pt-4 pb-2' : ''} ${
                                            idx === chargesPerPaxList.length - 1 ?
                                              'pt-2 pb-4' :
                                              ''
                                          }`}
                                        />
                                      </If>
                                      <td
                                        className={`pr-1 ${
                                          fareType ? 'w-200' : 'w-250'
                                        } ${
                                          idx !== 0 &&
                                          idx !== chargesPerPaxList.length - 1 ?
                                            'py-2' :
                                            ''
                                        } ${idx === 0 ? 'pt-4 pb-2' : ''} ${
                                          idx === chargesPerPaxList.length - 1 ?
                                            'pt-2 pb-4' :
                                            ''
                                        }`}
                                      >
                                        {endTime}
                                      </td>
                                      <td
                                        className={`pr-1 ${
                                          fareType ? 'w-200' : 'w-250'
                                        } ${
                                          idx !== 0 &&
                                          idx !== chargesPerPaxList.length - 1 ?
                                            'py-2' :
                                            ''
                                        } ${idx === 0 ? 'pt-4 pb-2' : ''} ${
                                          idx === chargesPerPaxList.length - 1 ?
                                            'pt-2 pb-4' :
                                            ''
                                        }`}
                                      >
                                        {getCurrencyByReq(charges, currency)}/{' '}
                                        {paxTypeMap[paxType] || ''}
                                      </td>
                                    </tr>
                                  </tbody>
                                )
                              }
                            )
                        )}
                    </React.Fragment>
                  )
                })}
            </table>
          </div>
        </If>
      </If>
    </If>
  )
}

export default FareRules
